// src/components/ChatHistory.tsx
import React, { useEffect, useState, useCallback } from 'react';
import { API_URL } from '../config';

interface ChatSummary {
  id: number;
  title: string;
  updated_at: string;
}

interface Props {
  token: string;
  activeChatId: number | null;
  onSelectChat: (id: number) => void;
  onNewChat: () => void;
  refreshTrigger: number;
}

export default function ChatHistory({
  token, activeChatId, onSelectChat, onNewChat, refreshTrigger
}: Props) {
  const [chats, setChats] = useState<ChatSummary[]>([]);

  const load = useCallback(() => {
    // FIX: get a fresh token each time load() is called instead of
    // capturing a potentially stale closure value
    const currentToken = token || localStorage.getItem('coderai_token') || '';
    if (!currentToken) return;
    fetch(`${API_URL}/chats.php`, {
      headers: { Authorization: `Bearer ${currentToken}` }
    })
      .then(r => r.json())
      .then(data => setChats(data.chats || []))
      .catch(console.error);
  }, [token]);

  // FIX: also reload whenever the token itself changes (e.g. after login)
  useEffect(() => { load(); }, [load, refreshTrigger, token]);

  const deleteChat = async (e: React.MouseEvent, id: number) => {
    e.stopPropagation();
    if (!window.confirm('Delete this chat?')) return;
    const currentToken = token || localStorage.getItem('coderai_token') || '';
    await fetch(`${API_URL}/chats.php?id=${id}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${currentToken}` }
    });
    if (activeChatId === id) onNewChat();
    load();
  };

  return (
    <div className="chat-history">
      {chats.length === 0 && (
        <p className="no-history">No saved chats yet</p>
      )}
      {chats.map(c => (
        <div
          key={c.id}
          className={`history-item ${c.id === activeChatId ? 'active' : ''}`}
          onClick={() => onSelectChat(c.id)}
        >
          <span className="history-title">{c.title}</span>
          <button className="history-delete" onClick={e => deleteChat(e, c.id)}>🗑</button>
        </div>
      ))}
    </div>
  );
}